import { createStore } from 'jotai'

// Only use the global store on client-side, since otherwise the global store might leak information on server side
export const store = typeof window === 'undefined' ? undefined : createStore()
